import React from 'react';
import { BodyText, HeadingText } from '@paypalcorp/pp-react';

import styles from './charityLogo.less';

import { isPPGF } from '../lib/charity';

export default class extends React.Component {
  render() {
    let title;

    if (isPPGF(this.props.charity_type)) {
      title = this.props.i18n('label.donate-with-ppgf');
    }

    const logoUrl =
      this.props.logo_url ||
      'https://www.paypalobjects.com/images/Cause/ic_donate1.svg';
    return (
      <div
        className={`npo-logo-container ${
          this.props.campaign ? `${styles['campaign-margin']}` : ''
        }`}
      >
        <div className={'npo-avatar-container'}>
          <div
            className={'npo-avatar'}
            style={{
              background: `url(${logoUrl}) no-repeat center, center`,
              backgroundSize: 'contain',
            }}
          />
        </div>
        <div className={'npo-logo-title'}>
          <BodyText as='p' size='md'>
            {title}
          </BodyText>
          <HeadingText as='h1' size='lg'>
            {this.props.name}
          </HeadingText>
        </div>
      </div>
    );
  }
}
